const imgs = {
    bg: `${process.env.PUBLIC_URL}/imgs/bg-not-found.png`,
    warning: `${process.env.PUBLIC_URL}/imgs/img_warning.png`,
};

const GlobalErrorBoundary = () => {
    return (
        <div className="fixed w-screen h-screen flex items-center justify-center">
            <img src={imgs["bg"]} width="80%" height="auto" className="absolute" />
            <img src={imgs["warning"]} width="114px" height="100px" className="absolute" />
        </div>
    );
};

export default GlobalErrorBoundary;
